import context from "@helpers/context"

const [
    FinishedDashboardContext, 
    useFinishedDashboardContext
] = context<Admin.Contexts.SalonDashboardFinished>()

export default FinishedDashboardContext
export { useFinishedDashboardContext }
